<template>
    <div class="px-3" v-if="campaign.customFacebookMessage != 'grade'">
        <div class="splide" id="campaign-pictures" v-if="imageList.length > 1">
            <div class="splide__track">
                <ul class="splide__list">
                    <li class="splide__slide"
                        v-for="(image, k) in imageList"
                        :key="k">
                        <img class="w-full rounded-xl shadow-lg" :src="image.fullImageUrl" alt="">
                    </li>
                </ul>
            </div>
        </div>
        <div v-else>
            <img class="w-full rounded-xl shadow-lg" :src="imageList[0].fullImageUrl" alt="">
        </div>
    </div>
    <div class="px-3" v-else-if="campaign.customFacebookMessage == 'grade'">
        <img class="w-full rounded-xl shadow-lg" :src="uGreadePicture" alt="">
    </div>
</template>
<script>
import Splide from '@splidejs/splide'; //https://splidejs.com/

export default {
    name: "Picture",
    props: {
        campaign: { type: Object, required: true },
    },
    inject: ["AccountStore"],
    data: function() {
        return {
            imageList: this.campaign.pictures,
            uGrade: null,
            uGreadePicture: null,
        };
    },
    mounted: function() {
        if (this.campaign.customFacebookMessage != 'grade') {
            if (this.imageList.length > 1) {
                new Splide('#campaign-pictures', {
                    type: 'loop',
                    arrows: false,
                }).mount();
            }
        }
    },
    created: function () {
        if (this.campaign.customFacebookMessage == 'grade') {
            this.uGrade = this.AccountStore.state.userGrade
            this.setUGradePicture();
        }
    },
    methods: {
        setUGradePicture: function() {
            switch (this.uGrade) {
                case 'U':
                    this.uGreadePicture = this.imageList[0].fullImageUrl;
                    break;
                case 'E':
                    this.uGreadePicture = this.imageList[1].fullImageUrl;
                    break;
                case 'P':
                    this.uGreadePicture = this.imageList[2].fullImageUrl;
                    break;
                default:
                    this.uGreadePicture = this.imageList[3].fullImageUrl;
                    break;
            }
        }
    }
}
</script>

